import clsx from 'clsx';

import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './mapSideNavigation.module.css';

interface Props {
  activeNavigationState: string;
  onNavigation: (navigateTo: string) => any;
}

const styles = {
  icon: {
    color: colors.neutral.gray,
    fontSize: 24,
  },
};

const MapSideNavigation = ({
  activeNavigationState: navigationState,
  onNavigation,
}: Props) => {
  const activeNavigationState = navigationState || 'list';

  return (
    <div className={classes.container}>
      <div className={classes.navLinkContainer}>
        <div
          className={clsx(
            classes.navLink,
            activeNavigationState === 'layers' && classes.active,
          )}
          onClick={() => onNavigation('layers')}
        >
          <Icon style={styles.icon}>layers</Icon>
        </div>
        <div
          className={clsx(
            classes.navLink,
            activeNavigationState === 'list' && classes.active,
          )}
          onClick={() => onNavigation('list')}
        >
          <Icon style={styles.icon}>view_list</Icon>
        </div>
      </div>
    </div>
  );
};

export default MapSideNavigation;
